import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=91222b0e&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=ts&"
export * from "./Blank.vue?vue&type=script&lang=ts&"
import style0 from "./Blank.vue?vue&type=style&index=0&id=91222b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91222b0e",
  null
  
)

export default component.exports